<template >
  <div> <img class="user-header-logo" :src="avatar">
    <h1 class="text-left">{{ name }}</h1>
    <b-form class="text-left" @submit.stop.prevent="handleSubmit">
      <br>
      Title
      <b-form-input type="text"
                    required
                    placeholder="Enter Job Title"
                    v-model="userObject.title">
      </b-form-input>
      <br>
      Default Mailbox
      <v-select v-model="defaultMailbox" :options="mailboxes_collection"/>
      <br>
      Timezone
      <v-select v-model="timeZone" :options="timezone_collection" />
      <br>
      Covering For
      <MultiUserSelector v-on:user-change="setCoverageUsers($event)" :parent="userObject" />
      <br>
      Clients
      <multiselect v-model="userObject.clients" :options="clients" :multiple="true" label="label" />
      <br>
      <template v-if="parent == 'editUser'">
        <b-form-checkbox id="userActive"
                         v-model="userObject.active"
                         value="true"
                         unchecked-value="false">
          Active
        </b-form-checkbox>
        <br>
      </template>

      <br>
      <b-button class="submit-board-btn" type="submit">Submit</b-button>
      <b-button @click="getUser()" variant="warning">Reset</b-button>
      <b-btn v-if="parent == 'profile'" class="float-right" @click="hideModal">Close</b-btn>
    </b-form>
  </div>
</template>

<script>
import { collectionsMixins } from '@/mixins/collectionsMixins'
import Multiselect from 'vue-multiselect'
import MultiUserSelector from '@/components/selectors/users/MultiUserSelector'
import { mapGetters } from 'vuex'
export default {
  name: 'userForm',
  components: {
    MultiUserSelector,
    Multiselect
  },
  mixins: [collectionsMixins],
  data () {
    return {
      userObject: {
        title: '',
        active: null,
        default_mailbox_id: null,
        time_zone: null,
        coverage_ids: [],
        clients_ids: [],
        clients: []
      },
      name: '',
      avatar: '',
      defaultMailbox: {},
      mailboxes_collection: [],
      timeZone: '',
      timezone_collection: []
    }
  },
  props: {
    parentUser: Object,
    parent: String
  },
  created () {
    this.getUser()
    this.mailboxesCollection()
  },
  methods: {
    getUser () {
      this.name = this.parentUser.name ? this.parentUser.name : this.parentUser.full_name
      this.avatar = this.parentUser.avatar ? this.parentUser.avatar : this.parentUser.avatar_url
      var id = this.parentUser.id
      this.$http.get('/users/' + id)
        .then(function (response) {
          this.userObject = response.data.user
          this.userObject.coverage_ids = response.data.user.covered_users.map(function (user) {
            return user.id
          })
          let clientIds = response.data.user.clients.map(function (client) {
            return client.id
          })
          this.userObject.clients = this.clients.filter(client => clientIds.includes(client.value))
          this.defaultMailbox = response.data.user.default_mailbox
          this.timeZone = response.data.user.time_zone
          this.timezone_collection = response.data.time_zones
        }.bind(this))
        .catch(e => { console.log(e) })
    },
    handleSubmit () {
      if (this.timeZone === null) {
        alert('Timezone must be present.')
        return
      }
      this.userObject.default_mailbox_id = this.defaultMailbox.value
      this.userObject.time_zone = this.timeZone.value
      this.userObject.client_ids = this.userObject.clients.map(client => { return client.value })
      this.strippedUser = this.userObject
      delete this.strippedUser.covered_users
      this.$http.put('/users/' + this.parentUser.id, { user: this.strippedUser })
        .then(function (response) {
          this.$root.$emit('userWasUpdated', {})
          this.$store.dispatch('loadUser')
          this.$store.dispatch('loadClients')
          this.hideModal()
        }.bind(this))
        .catch(e => { console.log(e) })
    },
    hideModal () {
      this.$root.$emit('bv::hide::modal', 'profile')
    },
    setCoverageUsers (user) {
      if (this.userObject.coverage_ids.includes(user.id)) {
        this.userObject.coverage_ids = this.userObject.coverage_ids.filter(function (id) {
          return id !== user.id
        })
      } else {
        this.userObject.coverage_ids.push(user.id)
      }
    }
  },

  computed: {
    ...mapGetters(['clients'])
  },

  watch: {
    parentUser: function () {
      this.getUser()
    }
  }
}
</script>

<style scoped>
.user-header-logo {
  vertical-align: top;
  border-radius: 50%;
  height: 75px;
  width: 75px;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/UserForm.vue